import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

@Injectable()
export class LocationService {
    private api_url_get_unplaced_items = './api/server.php?cmd=GET_UNPLACED_DOCKETS';
    private api_url_is_docket_unplaced = './api/server.php?cmd=IS_DOCKET_UNPLACED';
    private api_url_place_lots = './api/server.php?cmd=PLACE_LOTS';
    private api_url_valider_editer_lot_session = './api/server.php?cmd=VALIDER_EDITER_LOT_SESSION';
    private api_url_valider_editer_lot_session_2 = './api/server.php?cmd=VALIDER_EDITER_LOT_SESSION_2';
    private api_url_get_docket_details = './api/server.php?cmd=DOCKETS_ABSTRACT_FOR_LOCATION';
    private api_url_get_session_location = './api/server.php?cmd=GET_SESSION_LOCATION';
    private api_url_save_session_location = './api/server.php?cmd=SAVE_SESSION_LOCATION';
    private api_url_destroy_session_location = './api/server.php?cmd=DESTROY_SESSION_LOCATION';


    private api_url_get_location = './api/server.php?cmd=GET_EMPLACEMENTS';
    private api_url_get_no_child_location = './api/server.php?cmd=GET_NO_CHILD_EMPLACEMENTS';
    private api_url_get_location_tree = './api/server.php?cmd=GET_EMPLACEMENTS_TREE';
    private api_url_insert_new_location = './api/server.php?cmd=INSERT_NEW_LOCATION';
    private api_url_get_location_for_edition = './api/server.php?cmd=GET_EMPLACEMENTS_FOR_MODIF';
    private api_url_update_location = './api/server.php?cmd=UPDATE_LOCATION';
    private api_url_delete_location = './api/server.php?cmd=DELETE_LOCATION';
    private api_url_get_location_list_by_article = './api/server.php?cmd=GET_LOCATION_LIST_BY_ARTICLE';

    constructor(private http: Http) {}

    getDocketDetails(id_docket: string): Promise<Object> {
        return this.http.get(this.api_url_get_docket_details + '&id_docket=' + id_docket)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    getUnplacedItems(docket_name, date): Promise<Object> {
        return this.http.get(this.api_url_get_unplaced_items
            + '&reference_code=' + docket_name + '&date=' + date
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    getSessionLocation(id_docket: string): Promise<Object> {
        return this.http.get(this.api_url_get_session_location
            + '&id_docket=' + id_docket
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    saveSessionLocation(): Promise<Object> {
        return this.http.get(this.api_url_save_session_location)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    isDocketUnplaced(id_docket: number): Promise<Object> {
        return this.http.get(this.api_url_is_docket_unplaced
            + '&id_docket=' + id_docket
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    placeLots(id_movement: any) {
        return this.http.get(this.api_url_place_lots
            + '&id_movement=' + id_movement
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    validateEditLotSession(lot: any) {
        return this.http.get(this.api_url_valider_editer_lot_session
            + '&id_movement=' + lot.id_movement
            + '&quantity=' + lot.quantity
            + '&quantity_to_place=' + lot.quantity_to_place
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }
    validateEditLotSession2(emplacement: any, id_movement: any, quantity: any) {
        return this.http.get(this.api_url_valider_editer_lot_session_2
            + '&emplacement=' + emplacement
            + '&id_movement=' + id_movement
            + '&quantity=' + quantity
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    //    gestion emplacements
    getLocations(warehouse: any): Promise<Object> {
        return this.http.get(this.api_url_get_location
            + '&warehouse=' + warehouse
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    getNoChildLocations(): Promise<Object> {
        return this.http.get(this.api_url_get_no_child_location
            //            + '&warehouse=' + warehouse
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    getLocationsTree(warehouse: any, location_name: any, location_reference: any): Promise<Object> {
        return this.http.get(this.api_url_get_location_tree
            + '&warehouse=' + warehouse
            + '&location=' + location_name
            + '&reference=' + location_reference
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);

    }

    insertLocation(location: any, warehouse: any): Promise<Object> {
        return this.http.get(this.api_url_insert_new_location
            + '&warehouse=' + warehouse
            + '&location=' + location.new_location
            + '&reference=' + location.new_reference
            + '&reference_parent=' + location.new_reference_parent
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    getLocationsForEdition(warehouse: any, reference: any): Promise<Object> {
        return this.http.get(this.api_url_get_location_for_edition
            + '&warehouse=' + warehouse
            + '&reference=' + reference
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    updateLocation(location: any, warehouse: any): Promise<Object> {
        return this.http.get(this.api_url_update_location
            + '&warehouse=' + warehouse
            + '&id_location=' + location.id_location
            + '&location=' + location.new_location
            + '&reference=' + location.new_reference
            + '&reference_old=' + location.reference_old
            + '&reference_parent=' + location.new_reference_parent
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    deleteLocation(location: any): Promise<Object> {
        return this.http.get(this.api_url_delete_location
            + '&reference=' + location.new_reference
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetLocationListByArticle(id_article: number): Promise<Object> {
        return this.http.get(this.api_url_get_location_list_by_article + '&id_article=' + id_article)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/location.service.ts